import { useState } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseSupplier } from "./UseSupplier";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddSupplier() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [supplier, setSupplier] = useState();
  const { validate, addSupplier } = UseSupplier();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState({
    companyName: undefined,
    visitorName: undefined,
    visitorMobile: undefined,
    companyMobile: undefined,
    isEnable: false,
  });

  const [errorState, setErrorState] = useState({
    companyName: false,
    visitorName: false,
    visitorMobile: false,
  });
  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/suppliers" },
          { name: "تامین کننده جدید", url: "/suppliers/addSupplier" },
        ],
      }}
    >
      {!supplier ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.companyName ? state.companyName : ""}
              error={errorState.companyName}
              label="نام شرکت"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, companyName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.visitorName ? state.visitorName : ""}
              error={errorState.visitorName}
              label="نام ویزیتور"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, visitorName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.visitorMobile ? state.visitorMobile : ""}
              error={errorState.visitorMobile}
              sx={{
                input: { direction: "rtl" },
              }}
              label="شماره ویزیتور"
              variant="outlined"
              size="small"
              onChange={(event) => {
                setState({ ...state, visitorMobile: event.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.companyMobile ? state.companyMobile : ""}
              error={errorState.companyMobile}
              sx={{
                input: { direction: "rtl" },
              }}
              label="شماره شرکت"
              variant="outlined"
              size="small"
              onChange={(event) => {
                setState({ ...state, companyMobile: event.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <FormControlLabel
              checked={state.isEnable}
              onChange={(evt) => {
                setState({ ...state, isEnable: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فعال"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end" }}
            gridColumn="span 3"
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  addSupplier(state, () => {
                    setMsGotoLast(true);
                    navigate("/suppliers", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/suppliers", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
